<template>
  <div class="ServiceChatroom">
    <van-nav-bar title="客服小蜜" fixed border left-arrow class="van-nav" @click-left="onClickLeft">
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <div class="content" ref="ref_content" :style="{height: scrollerHeight}">
      <template v-for="(item,index) in chatMessage" v-if="item.content">
        <!-- 右对齐 -->
        <van-row type="flex" justify="end" v-if="item.id == u_id" :key="index+'a'">
          <div>
            <van-image
              class="err-image-header"
              round
              width="45px"
              height="45px"
              :src="attach_url+item.headPortrait"
              @click="headPortrait(item.id)"
            />
            <van-col>
              <div class="entry2">
                <div class="entry-trangle-right">
                  <!--本Div只来实现三角形，无其他作用-->
                </div>
                <div class="span-content">{{item.content}}</div>
              </div>
            </van-col>
          </div>
        </van-row>
        <!-- 左对齐 -->
        <van-row type="flex" v-if="item.id != u_id" :key="index+''">
          <div>
            <van-image
              round
              width="45px"
              height="45px"
              class="headPortrait"
              :src="item.headPortrait"
              @click="headPortrait(item.id)"
            />
            <van-col>
              <div class="entry1">
                <div class="entry-trangle-left">
                  <!--本Div只来实现三角形，无其他作用-->
                </div>
                <div class="span-content">{{item.content}}</div>
              </div>
            </van-col>
          </div>
        </van-row>
      </template>
    </div>
    <div class="bottom-bar">
      <div class="v-tabbar">
        <van-field
          class="sendc"
          v-model="content"
          :clearable="true"
          border
          type="textarea"
          placeholder="请输入内容"
          @click="showOf()"
          @keyup.ctrl.enter.native="onTextareaKeyDown()"
        />
        <van-button class="send" :style="{ width: '20%'}" type="info" @click="send">发送</van-button>
      </div>
    </div>
    <audio controls="controls" hidden src="./static/mp3/system.wav" ref="audio"></audio>
  </div>
</template>
<script>
export default {
  name: "ServiceChatroom",
  data() {
    return {
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
      chatMessage: [],
      content: "",
      show: false,
      photoShow: false,
      faceshow: false,
      functionshow: false,
      path: "",
      attach_url: this.Conf.serverPre
    };
  },
  mounted() {
 
    // 初始化
    this.websocket.ws.onmessage = this.getMessage;
    // 进入客服小蜜页面自动发送回复
    var params = {
      u_id: this.u_id,
      mk: 4
    };
    this.websocket.ws.send(JSON.stringify(params));
    this.$nextTick(() => {
      // console.log("屏高", window.screen.height, window.innerHeight);
      this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
    });
  },
  computed: {
    // 滚动区高度
    // (业务需求：手机屏幕高度减去头部标题和底部tabbar的高度，当然这2个高度也是可以动态获取的)
    scrollerHeight: function() {
      return window.innerHeight - 40 - 60 + "px";
    }
  },
  // 在模板渲染成html前调用，即通常初始化某些属性值，然后再渲染成视图。
  created() {
  	this.getStateConfigs();
    this.path = this.$route.query;
    this.scrollToBottom();
  },
  methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
    scrollToBottom() {
      // 滚动
      this.$nextTick(() => {
        this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
      });
    },
    showOf() {
      this.show = false;
    },
    onTextareaKeyDown() {
      if (event.keyCode == 13) {
        //如果按的是enter键 13是enter
        event.preventDefault(); //禁止默认事件（默认是换行）
        this.send(); //执行发送动作
      }
    },
    onClickLeft() {
      // 返回
      this.$router.push({
        name: this.path.url,
        query: {
          active: this.path.active
        }
      });
    },
    // 监听socket消息回调
    getMessage: function(msg) {
      var data = JSON.parse(msg.data);
      switch (data.status) {
        case 1:
          // token为空时
          this.$dialog
            .alert({
              message: data.message
            })
            .then(() => {
              // on close
              this.$router.push({ path: "/login" });
            });
          break;
        case 2:
             // 重新连接socket fd改变，客户端与服务端token相等时，不退出登入
          if (this.token == data.token) {
            return;
          }
          // 用户在别处登录，客服端与服务端token不相等时
          // 客户端token 与 后台token不相等时，退出登入
           window.localStorage.clear();
          this.$dialog
            .alert({
              message: data.message
            })
            .then(() => {
              // on close
              this.$router.push({ path: "/login" });
            });
          break;
        case 3:
          if (!data.message) {
            var message = "您好！我是客服小蜜，很高兴为您服务！请输入关键字:";
            data.keywords.forEach(item => {
              message += "<" + item.keyword + ">,";
            });
            var m = {
              id: "",
              headPortrait: "static/icon/kefu1.png",
              content: message + "如有其它问题请联系在线客服，谢谢！"
            };
            this.chatMessage.push(m);
          } else {
            this.chatMessage.push(data.message);
          }
          if (data.u_id == this.u_id) {
            //播放声音
            this.$refs.audio.currentTime = 0; //从头开始播放提示音
            this.$refs.audio.play(); //播放
          }
          //收到服务器信息，心跳重置
          //this.reset();
          break;
      }
      // console.log(data);
    },
    // 发送消息
    send() {
      if (!this.content) {
        return this.$toast("输入不能为空！");
      } else {
        var params = {
          u_id: this.u_id,
          message: this.content,
          mk: 3
        };
        this.websocket.ws.send(JSON.stringify(params));
        this.content = "";
        this.websocket.ws.onmessage = this.getMessage;
         setTimeout(_ => {
          this.$nextTick(() => {
            this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
          });
        }, 500);
      }
    },
    headPortrait(id) {
      // console.log(id);
    },
    // 弹出表情包
    showPopup() {
      this.show = true;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/AddressList/ServiceChatroom.vue